// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import styled from 'styled-components';
var BadgeDiamondStyles = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-n48lv7-0"
})(["\n  @keyframes customBadgeFadeIn {\n    from {\n      transform: translateY(-50%);\n      height: 90%;\n      opacity: 0;\n    }\n\n    to {\n      transform: translateY(0);\n      height: auto;\n      opacity: 1;\n    }\n  }\n"]);
export default BadgeDiamondStyles;